<template>
  <div class="ui-mobile-input" :class="[disabled ? 'disabled' : '']">
    <div class="ui-mobile-input__code"
         @click="handleSelectCode">
      {{ inputCode ? `+${inputCode}` : '' }}
    </div>
    <nio-input class="ui-mobile-input__mobile" v-model="inputMobile" :placeholder="placeholder" :limit="limit"></nio-input>
    <section v-if="isPc"
             v-show="showModal"
             class="ui-mobile-input__select-list-inner">
      <div v-for="(option, i) in selectList"
           :key="i"
           class="ui-mobile-input__select-item"
           @click="onSelectChange(option)">
        {{ option.label }}
      </div>
    </section>
    <nio-modal v-else :visible.sync="showModal" :options="selectList" @change="onSelectChange"></nio-modal>
  </div>
</template>

<script>
import NioInput from './NioInput';
import NioModal from "./NioModal";

export default {
  name: 'NioMobileInput',
  components: {
    NioInput,
    NioModal
  },
  props: {
    value: {
      type: [Object, String],
      default: () => ({
        calling_code: '',
        number: ''
      })
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number
    }
  },
  data(){
    return {
      inputCode: this.value ? this.value.calling_code : '',
      inputMobile: this.value ? this.value.number : '',
      showModal: false,
      selectList: [
        {label: '+31', value: '31'},
        {label: '+45', value: '45'},
        {label: '+46', value: '46'},
        {label: '+47', value: '47'},
        {label: '+49', value: '49'},
        {label: '+86', value: '86'}
      ],
      clientWidth: 0
    };
  },
  watch: {
    value(newVal){
      this.inputCode = newVal.calling_code;
      this.inputMobile = newVal.number;
    },
    inputCode(newVal){
      this.$emit('input', {calling_code: newVal, number: this.inputMobile});
      this.$emit('change');
    },
    inputMobile(newVal){
      this.$emit('input', {calling_code: this.inputCode, number: newVal});
      this.$emit('change');
    }
  },
  computed: {
    isPc() {
      return this.clientWidth > 1023;
    }
  },
  mounted(){
    this.clientWidth = window.innerWidth || document.body.clientWidth;
  },
  methods: {
    handleSelectCode(){
      this.showModal = !this.showModal;
    },
    onSelectChange({value}){
      this.inputCode = value;
      if (this.isPc) {
        this.showModal = !this.showModal;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/standard";
@import "../../assets/scss/mixins";

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.ui-mobile-input {
  position: relative;
  display: flex;
  justify-content: space-between;

  &.disabled {
    pointer-events: none;
  }

  &__code {
    width: sizeTrans(64);
    min-width: sizeTrans(64);
    margin-right: sizeTrans($space_15);
    border-bottom: 1px solid $color_mb3_front;
    @include font_text_m();
    color: $color_bs1_front;
    cursor: pointer;
  }

  &__mobile {
    flex: 1;
  }

  &__select-list-inner {
    position: absolute;
    width: 100%;
    left: 0;
    top: sizeTrans(29);
    background-color: #FFFFFF;
    z-index: 10;
    border: 1px solid $color_mb3_front;
    animation-name: fadeIn;
    animation-duration: 0.3s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: initial;
  }

  &__select-item {
    height: sizeTrans(60);
    line-height: sizeTrans(60);
    font-size: sizeTrans(16);
    color: $color_mb1_front;
    text-align: center;
    @include ellipsis();
    &:hover {
      background-color: $color_bs3_back;
    }
  }
}
</style>